











































































import {Component, Prop, Vue} from 'vue-property-decorator';
import ZCLogo from '../assets/logo.svg';
import {ITicket, TicketStore} from '@/store/modules/ticket.store';
import {PhoneNumberFilter} from '@/filters/phone-number';
import {WebService} from '@/services/web.service';
import { OverlayShowTime } from '@/constants';
// @ is an alias to /src

@Component({
	components: {
		ZCLogo
	}
})
export default class PaidBill extends Vue {
	@Prop({default: null})
	ticketId!: string | null;

	showCompletedOverlay = false;
	overlayColor = '';
	overlayMessage = '';

	showOverlay = false;

	showLoading = false;

	fields = [
		{
			key: 'paymentName',
			label: ''
		},
		{
			key: 'amount',
			label: 'Amount'
		},
		{
			key: 'tip',
			label: 'Tip'
		},
		{
			key: 'time',
			label: 'Time'
		},
	];

	get ticket(): ITicket | null {
		if(this.ticketId === null) {
			return null;
		}
		return TicketStore.byId(this.ticketId);
	}

	get customerMobile() {
		if(this.ticket === null || this.ticket.customer.phone === null) {
			return 'None';
		}
		return PhoneNumberFilter(this.ticket.customer.phone);
	}

	get customerName() {
		if(this.ticket === null || this.ticket.customer.name === '') {
			return 'None';
		}
		return this.ticket.customer.name;
	}

	get tableName() {
		if(this.ticket === null || this.ticket.tableName === null) {
			return 'None';
		}
		return this.ticket.tableName;
	}

	created() {
		if(this.ticket === null) {
			this.close();
		}
	}

	get payments() {
		if(this.ticket === null || !this.ticket.payments) {
			return [];
		}
		return this.ticket.payments.map((payment) => {
			return {
				paymentName: '', // Don't have this data from the API yet
				amount: payment.amount,
				tip: payment.gratuity,
				time: payment.paidDate
			};
		});
	}

	get amountTotal() {
		return this.payments.reduce((total, item) => {
			return total + item.amount;
		}, 0);
	}

	get tipTotal() {
		return this.payments.reduce((total, item) => {
			return total + item.tip;
		}, 0);
	}

	tipPercent(amount: number, tip: number) {
		return Math.round(tip / amount * 100);
	}

	async complete() {
		try {
			this.showLoading = true;
			await WebService.closeTicket((this.ticket as ITicket).ticketId);
			this.showLoading = false;
			this.overlayColor = 'blue';
			this.overlayMessage = `Ticket completed`;
			this.showCompletedOverlay = true;
			setTimeout(() => {
				this.showCompletedOverlay = false;
				this.close();
			}, OverlayShowTime);
		} catch(e) {
			this.showLoading = false;
			console.log(e);
			await this.$bvModal.msgBoxOk('There was a problem closing your ticket', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}

	close() {
		this.showOverlay = false;
	}

	finalClose() {
		this.$emit('close');
	}

}
